module.exports = __webpack_public_path__ + "img/footer-logo.b7f7d4aa.png";